import { useChatInputStore } from '@/store';

export const isChatablePathname = (pathname = '') =>
  pathname.startsWith('/app') ||
  pathname.startsWith('/c/') ||
  pathname.startsWith('/g/') ||
  pathname.startsWith('/m/') ||
  /^\/collections\/[^/]+/.test(pathname);

export const getChatInputContextIdFromPathname = (pathname = '') => {
  if (pathname.startsWith('/app')) return 'new';
  const chatMatch = pathname.match(/^\/c\/([^/]+)/);
  if (chatMatch) return chatMatch[1];
  const modelMatch = pathname.match(/^\/m\/([^/]+)/);
  if (modelMatch) return `new-${modelMatch[1]}`;
  const agentMatch = pathname.match(/^\/g\/([^/]+)/);
  if (agentMatch) return `new-${agentMatch[1]}`;
  // Collection detail pages mount their composer with
  // conversationId = `new-<collectionId>` (see app/(app)/collections/[id].jsx).
  const collectionMatch = pathname.match(/^\/collections\/([^/]+)/);
  if (collectionMatch) return `new-${collectionMatch[1]}`;
  return null;
};

export const appendUploadedFilesToComposer = (pathname, uploadedFiles) => {
  const successfulFiles = uploadedFiles?.results
    ?.filter(result => result.status === 'success' && result.uploadedFile?.id)
    ?.map(result => result.uploadedFile) ?? [];

  if (!isChatablePathname(pathname) || successfulFiles.length === 0) return;

  const contextId = getChatInputContextIdFromPathname(pathname);
  if (!contextId) return;

  useChatInputStore.getState().addFilesToContext(contextId, successfulFiles);
};
